import { Controller } from 'stimulus';
import '@/js/modules/jquery_modal_defaults';

export default class extends Controller {
  connect() {
    this.onClose = () => this.dispatch('close');
    $(this.element).on($.modal.CLOSE, this.onClose);
  }

  disconnect() {
    $(this.element).off($.modal.CLOSE, this.onClose);
  }

  close() {
    $.modal.close();
  }
}
